<template>
  <div class="home-page">
    <HomeBanner :config="config" />
  </div>
</template>

<script>
import HomeBanner from '../components/HomeBanner.vue'

export default {
  name: 'Home',
  components: {
    HomeBanner
  },
  props: {
    config: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.home-page {
  min-height: 100%;
}
</style>
